import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { DEFAULT_STATUS_OPTIONS } from "@/constants";

/**
 * Hook to fetch status options from the 'estatus' catalog.
 * Falls back to DEFAULT_STATUS_OPTIONS if empty or failed.
 */
export function useStatusOptions() {
  const { data, isLoading } = useQuery({
    queryKey: ["catalogs", "estatus"],
    queryFn: async () => (await api.get("/catalogs", { params: { type: "estatus" } })).data,
    staleTime: 30_000,
  });
  const items = (data || []).map((c) => c.name);
  return {
    options: items.length > 0 ? items : DEFAULT_STATUS_OPTIONS,
    isLoading,
  };
}
